<template>
  <div>
    <div
      class="popup-gen fixed inset-0 z-[calc(var(--z-panel)+2)] flex flex-col items-center justify-stretch pt-12 pl-(--left-rail-width)
             max-sm:top-(--mobile-header-height) max-sm:bottom-(--mobile-nav-height)
             max-sm:overflow-hidden max-sm:p-0"
      v-if="fullPage"
      :class="{ withTabs }"
    >
      <CloseButton
        class="close absolute! top-18.75 right-6.25 z-10 max-sm:hidden"
        v-if="showCloseButton"
         @click="emit('close')"
      >
      </CloseButton>
      <div
        class="content-col relative flex min-h-full w-full flex-1 flex-col justify-center
               max-sm:h-full max-sm:w-full! max-sm:max-w-full!"
      >
        <div class="popup-bg fixed inset-0 bg-(--project-background-overlay) bg-light-gradient" v-if="contentScrim"></div>
        <div
          class="content-container relative flex max-h-full flex-1 flex-col items-center justify-start
                 max-sm:h-full max-sm:w-screen max-sm:min-w-screen max-sm:max-w-screen
                 max-sm:overflow-x-hidden max-sm:overflow-y-auto max-sm:bg-[unset] max-sm:p-0
                 max-sm:[&::-webkit-scrollbar]:hidden max-sm:[&::-webkit-scrollbar]:w-0"
          @scroll="fullPage && onContentScroll($event)"
        >
          <slot></slot>
        </div>
      </div>
    </div>
    <div
      v-else
      ref="smallPopupRef"
      class="small-popup absolute z-(--z-modal) [transform:translate(-50%,-50%)] rounded-[1.125rem] bg-bg2
             px-7.5 py-3.75 shadow-[1px_1px_6px_var(--shadow-color)]"
      :style="{ width: popupWidth, height: popupHeight, top: popupTop, left: popupLeft}"
    >
      <div class="popup">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import { onClickOutside } from '@vueuse/core';
import CloseButton from './CloseButton.vue';

const props = defineProps({
  showCloseButton: Boolean,
  fullPage: Boolean,
  popupWidth: {
    type: String,
    default: '',
  },
  popupHeight: {
    type: String,
    default: '',
  },
  popupTop: {
    type: String,
    default: '50%',
  },
  popupLeft: {
    type: String,
    default: '50%',
  },
  withTabs: {
    type: Boolean,
    default: false,
  },
  contentScrim: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['close']);

const store = useStore();

function onContentScroll(e) {
  const scrolled = e.target.scrollTop > 0;
  if (scrolled !== store.state.system.pageScrolled) store.commit('system/setPageScrolled', scrolled);
}
onUnmounted(() => props.fullPage && store.commit('system/setPageScrolled', false));

// Create a ref for the small popup element
const smallPopupRef = ref(null);




// Setup onClickOutside for small popup
onClickOutside(smallPopupRef, (event) => {
  emit('close');
}, { 
  detectIframe: false 
});


</script>

<style lang="scss" scoped>
  .dialogWrapper {
    position: fixed;
    z-index: var(--z-panel);
    top: 42px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    .popup {
      padding: 10px;
      background-color: var(--bg2);
      display: flex;
      margin-top:-100px;
      min-width: 800px;
      min-height: 487px;
      max-height: 487;
    }

    &.animation {
      animation: show 0.2s forwards;
    }
  }

  .head {
    max-height: 130px;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    line-height: 28px;
    padding-bottom: 20px;
    color: var(--text);
  }
  @-webkit-keyframes show {
    0% {
      opacity: 0;
      transform: translateY(-100%);
    }
    50% {
      opacity: 0.2;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes show {
    0% {
      opacity: 0;
      transform: translateY(-100%);
    }
    50% {
      opacity: 0.2;
    }
    100% {
      opacity: 1;
    }
  }

  @media screen and (max-width: 600px) { //mobile
    .popup-gen {
      min-height: unset;
      max-height: unset;
      border-radius: 0;
    }
    .general-wrapper .general-panel .project-prefix-input .preview {
      width: unset;
    }
  }



</style>
